import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { I18n } from 'react-redux-i18n';
import './input.scss';

Input.propTypes = {
    className: PropTypes.string,
    label: PropTypes.string,
    onChange: PropTypes.func,
    autoComplete: PropTypes.oneOf(['off', 'on']),
    otherProps: PropTypes.shape()
};

export default function Input({
    className,
    label,
    onChange = () => {},
    autoComplete = 'off',
    ...otherProps
}) {
    const { type } = otherProps;
    const inputId = useState(() => Math.random().toString())[0];
    const [errorMessage, setErrorMessage] = useState('');
    const hasValidatedRef = useRef(false);
    const inputClassName = classNames('custom-input', className);
    const labelClassName = classNames('custom-label', {
        required: otherProps.required
    });
    const Tag = getInputTag(type);
    const placeholder = otherProps.placeholder ?? getPlaceholder(type);
    const showErrorMessage = type !== 'submit';

    function handleChange(e) {
        if (hasValidatedRef.current) {
            checkValidity(e.currentTarget);
        }

        onChange(e);
    }

    function handleInvalid(e) {
        e.preventDefault();
        hasValidatedRef.current = true;
        checkValidity(e.currentTarget);
    }

    function checkValidity(target) {
        const checkTypes = [
            'patternMismatch',
            'valueMissing'
        ];
        let errorMessage = '';
        const { validity } = target;
        const { valid } = validity;

        if (!valid) {
            errorMessage = I18n.t('form.general-error-message');
            checkTypes.forEach(type => {
                if (validity[type]) {
                    errorMessage = I18n.t(`form.${ type }`);
                }
            });
        }

        setErrorMessage(errorMessage);
    }

    return (
        <div className="custom-input-wrapper">
            { label && (
                <label className={ labelClassName } htmlFor={ inputId }>{ label }</label>
            ) }
            <Tag
                id={ inputId }
                className={ inputClassName }
                placeholder={ placeholder }
                autoComplete={ autoComplete }
                onChange={ handleChange }
                onInvalid={ handleInvalid }
                { ...otherProps }
            />
            { showErrorMessage && (
                <p className="error-message">{ errorMessage }</p>
            ) }
        </div>
    );
}

function getInputTag(type) {
    switch (type) {
    case 'textarea':
        return 'textarea';
    default:
        return 'input';
    }
}

function getPlaceholder(type) {
    switch (type) {
    case 'tel':
        return I18n.t('form.phone-placeholder');
    default:
        return undefined;
    }
}
